import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, matchPath, Link } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import SideDrawer from "./SideDrawer";
import { useAudioPlayer } from "../context/AudioPlayerContext";
import { courseModules } from "../data/courseModules";
import QuizSummary from './QuizSummary'; // Import the QuizSummary component

const Header = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { setCurrentTrack, currentTrack } = useAudioPlayer();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();
  const disableMenu = location.pathname ===  '/registration-success' || location.pathname ===  '/registration';

  useEffect(() => {
    const match = matchPath({ path: "/module/:moduleId/*" }, location.pathname);
    if (match && match.params.moduleId) {
      const matchedModuleId = match.params.moduleId;
      let id;
      if (matchedModuleId === 'prologue') {
        id = 'module-prologue';
      } else if (matchedModuleId === 'epilogue') {
        id = 'module-epilogue';
      } else {
        id = `module-${matchedModuleId}`;
      }
      const module = courseModules.find((m) => m.id === id);
      if (module && module.audio && module.audio.audioUrl !== currentTrack?.audioUrl) {
        setCurrentTrack(module.audio);
      }
    }
  }, [location.pathname, currentTrack, setCurrentTrack, user]);

  const showHamburgerMenu = true;//isMobile

  return (
    <header className="app-header">
      <div className="header-left">
        {showHamburgerMenu && (
          <button
            onClick={() => setDrawerOpen(true)}
            className="hamburger-menu-button"
          >
            ☰
          </button>
        )}

        <SideDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
        <div
          className="header-brand"
          onClick={() => navigate('/home')}
          style={{ cursor: "pointer" }}
        >
          <img
            src="/brand-avatar.png"
            alt="S"
            className="header-avatar"
            style={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              border: "2px solid #4ECDC4",
            }}
          />
          <span className="header-brand-mark">Sai Sruti</span>{" "}
        </div>
      </div>
      <div className="header-center">
        {/* {!isMobile && <DesktopNav />} */}
      </div>
       {user && user.role === 'admin' && <div style={{ marginBottom: '20px', marginTop: '20px', paddingRight: 15 }}>
              <Link to="/admin/dashboard" style={{ textDecoration: 'none', color: 'white', fontWeight: 'bold' }}>
                  Admin Dashboard 
              </Link>
            </div>}
      <div className="header-right">
          <>
            {/* <input
              type="text"
              className="search-bar"
              placeholder={t("common.search")}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            /> */}
              {!disableMenu && <QuizSummary />}
          </>
      </div>
    </header>
  );
};

export default Header;
